<!-- Modal Header -->
<div class="modal-header">
  <h2 class="modal-title">{{ exercise?.name }}</h2>
  <span class="modal-cancel" (click)="closeModal()">&times;</span>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="exercise-image-container d-flex justify-content-center align-items-center"> <!-- Add flex classes here -->
        <img [src]="exercise?.imageUrl" alt="{{ exercise?.name }} Image" class="modal-image img-fluid">
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="exercise-details">
        <div class="exercise-section">
          <h3 class="section-title">S čim se ukvarjamo</h3>
          <p class="section-content">{{ exercise?.description }}</p>
        </div>
        <div class="exercise-section">
          <h3 class="section-title">Kdaj treniramo</h3>
          <p class="section-content">{{ exercise?.schedule }}</p>
        </div>
        <div class="exercise-section">
          <h3 class="section-title">Vadnina</h3>
          <p class="section-content">{{ exercise?.cost }}</p>
        </div>
        <div class="exercise-section">
          <h3 class="section-title">Vodja</h3>
          <p class="section-content">{{ exercise?.leader }} - <a href="tel:{{ exercise?.leaderPhone }}">{{ exercise?.leaderPhone }}</a></p>
        </div>
        <div class="exercise-section">
          <h3 class="section-title">Vaditelji</h3>
          {{ exercise?.trainers }}
        </div>
      </div>  
    </div>
  </div>
</div>
